import { EOrderSide } from "../IQuery";

export interface IOrderPositions {
  id: number;
  user_id: number;
  product_id: number;
  customer_account: string;
  position_id: number;
  symbol: string;
  is_open: boolean;
  buy_average_price: number;
  sell_average_price: number;
  points: number;
  profit_loss: number;
  is_daytrade: boolean;
  open_date: string;
  close_date: string;
  clorderid: string;
  order_side: string;
  sending_time: string;
  execution_time: string;
  order_status: string;
  reject_desc: string;
  order_analyst_id: number;
  average_price: number;
  quantity: number;
  organization_name: string;
  display_name: string;
  organization_id: number;
  instrument_refers_type: number;
  currency: string;
  help_reject_url: string;
}

export interface IResponseOrderPositions {
  data: IOrderPositions[];
  totalElements: number;
  totalPages: number;
  lastUpdated: Date;
}

export enum EDateType {
  TODAY = "TODAY",
  LAST_30_DAYS = "LAST_30_DAYS",
  SINCE_BEGINNING = "SINCE_BEGINNING",
}

export interface IProfitLoss {
  profit_loss: [
    {
      symbol: string;
      profit_loss: string | number;
    }
  ];
}

export interface IResponsePositionGraphic {
  total_by_currency: ITotalByCurrency[];
  items: IPositionGraphic[];
}

export interface ITotalByCurrency {
  refers_type: number;
  currency: string;
  total_number: number;
  total_text: string;
}
export interface IPositionGraphic {
  product_id: number;
  symbol: string;
  user_id: number;
  profit_loss: number;
  qtd_positions: string;
  qtd_orders: string;
  orders_success: string;
  orders_fail: string;
  product_title: string;
  refers_type: number;
  currency: string;
  profit_loss_text: string;
}

export interface IResponsePositions {
  data: IPositions[];
  totalElements: number;
  totalPages: number;
  lastUpdated: Date;
}

export enum EColorIconInfo {
  GREEN = "GREEN",
  RED = "RED",
  YELLOW = "YELLOW",
  WHITE = "WHITE",
  GRAY = "GRAY",
}
export interface IPositions {
  id: number;
  user_display_name: string;
  product_title: string;
  seq_num: number;
  symbol: string;
  available_quantity: any;
  average_price: string;
  buy_average_price: string;
  sell_average_price: string;
  profit_loss: string;
  open_date: string;
  close_date: string;
  is_open: string;
  analyst_position_id: any;
  status_copy: EColorIconInfo;
  status_copy_text: string;
  side_opening: EOrderSide;
  side_opening_text: string;
  user_name: string;
}

export interface IResponsePositionsDetail {
  data: IPositions[];
  totalElements: number;
  totalPages: number;
}
